import {createFileRoute} from '@tanstack/react-router';

import support from '@/public/views/Support';

export const Route = createFileRoute('/(public)/support')({
  component: support
});
